import { Component, OnDestroy } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { SnCommonModule } from '@lib/common';
import { snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';
import { t, TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { LprExport } from '@lib/vehicle-intelligence/api/models/lpr-export.model';
import { LprExportStatusComponent } from '@lib/vehicle-intelligence/components/lpr-export-status/lpr-export-status.component';

@Component({
  selector: 'fs-alpr-search-exports-table',
  templateUrl: './alpr-search-exports-table.component.html',
  animations: [snListStagger, snFadeIn, snFadeOut],
  imports: [
    MatTableModule,
    MatSortModule,
    SnCommonModule,
    LprExportStatusComponent,
    SnActionsModule,
    TranslationModule,
  ],
  standalone: true,
})
export class AlprSearchExportsTableComponent
  extends SnTableBaseComponent<LprExport>
  implements OnDestroy
{
  constructor() {
    super();
  }

  public trackBy(index: number, item: LprExport) {
    return item.id;
  }

  public getProcessingTimeInSeconds(item: LprExport): number {
    if (!item.startedAt || !item.completedAt) {
      return 0;
    }

    const createdDate = new Date(item.startedAt);
    const completedDate = new Date(item.completedAt);
    return Math.floor((completedDate.getTime() - createdDate.getTime()) / 1000);
  }

  public _calculateExpiresDate(item: LprExport) {
    if (!item.startedAt) {
      return t('alpr.fallbacks.notAvailable');
    }
    const expires = new Date(item.startedAt);
    expires.setDate(expires.getDate() + 7);

    return expires;
  }
}
